import React from 'react';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'connected-react-router';
import Amplify from 'aws-amplify';
import RouterMain from './routers';
import generateStore from './reducers';
import {history} from './reducers/config';
import {config} from './utils/amplify-config';

const store = generateStore();
Amplify.configure(config);

const App = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <RouterMain />
      </ConnectedRouter>
    </Provider>
  );
};

export default App;
